import { GET_TOGGL_DATA } from "../actions/types";

const initialState = {
  data: null,
  lastPeriod: null,
};

export default function togglReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TOGGL_DATA:
      return { ...state, data: action.payload, lastPeriod: action.period };
    default:
      return state;
  }
}
